import { render, staticRenderFns } from "./WorkProcedureTable.vue?vue&type=template&id=1564bc54"
import script from "./WorkProcedureTable.vue?vue&type=script&lang=js"
export * from "./WorkProcedureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports